import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import BcReactComponent from '@bibliocommons/base-bc-react-component';
import NotFound from '@bibliocommons/not-found';

import { currentUserSelector } from '../selectors/AuthSelector';
import { getRequestedUser } from '../selectors/UserSelector';
import UserActions from '../actions/UserActions';

export class UserContainer extends BcReactComponent {
  static fetchInitialData(params, query, store) {
    return [store.dispatch(UserActions.fetchUser(params.userId))];
  }

  componentWillReceiveProps(nextProps) {
    const { user } = this.props;
    const { params: nextParams, userActions } = nextProps;
    const userId = (user && user.get('id')) || undefined;
    const nextUserId = nextParams.userId ? parseInt(nextParams.userId, 10) : undefined;

    if (nextUserId !== userId) {
      userActions.fetchUser(nextParams.userId);
    }
  }

  render() {
    const { user } = this.props;

    if (user && user.get('active')) {
      return (
        <div>
          {this.props.children}
        </div>
      );
    }

    return (
      <NotFound />
    );
  }
}

UserContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  user: ImmutablePropTypes.map
};

const mapStateToProps = (state, ownProps) => ({
  user: ownProps.params.userId ? getRequestedUser(state) : currentUserSelector(state)
});

const mapDispatchToProps = dispatch => ({
  userActions: bindActionCreators(UserActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(UserContainer);



// WEBPACK FOOTER //
// ./app/containers/UserContainer.jsx